import type {RegisterAriaController} from '@wandb/forge-shell-contract/aria';
import {useEffect} from 'react';

import {useLocalWBAgentController} from './useWBAgentController';

export function AriaControllerRegistration({
  register,
}: {
  register?: RegisterAriaController;
}) {
  const controller = useLocalWBAgentController();
  useEffect(() => register?.(controller), [controller, register]);
  return null;
}
